/* eslint-disable react/prop-types */
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  Option,
  Select,
  Typography,
} from '@mui/joy';

/**
 * Inline tracking-event controls for entity save forms.
 * Sets create_tracking_event / tracking_event_timestamp via parent on submit.
 */
export default function TrackingEventControlFields({
  mode = 'auto',
  onModeChange,
  timestampLocal = '',
  onTimestampChange,
  disabled = false,
  timestampError = '',
  anchorRef,
}) {
  const { t } = useTranslation('ui');
  const showTimestamp = mode === 'record';

  return (
    <FormControl ref={anchorRef} sx={{ width: '100%' }}>
      <FormLabel>{t('trackingEventControl.inlineSectionTitle')}</FormLabel>
      <Select
        value={mode}
        onChange={(_, v) => {
          if (typeof onModeChange === 'function') onModeChange(v || 'auto');
        }}
        disabled={disabled}
        sx={{ width: '100%' }}
      >
        <Option value="auto">{t('trackingEventControl.auto')}</Option>
        <Option value="skip">{t('trackingEventControl.skip')}</Option>
        <Option value="record">{t('trackingEventControl.record')}</Option>
      </Select>
      <Typography level="body-xs" sx={{ color: 'neutral.600', mt: 0.5 }}>
        {t('trackingEventControl.inlineHint')}
      </Typography>
      {showTimestamp ? (
        <FormControl error={!!timestampError} sx={{ mt: 1.5 }}>
          <FormLabel>{t('trackingEventControl.timestampLabel')}</FormLabel>
          <Input
            type="datetime-local"
            value={timestampLocal}
            onChange={(e) => {
              if (typeof onTimestampChange === 'function') onTimestampChange(e.target.value);
            }}
            disabled={disabled}
            slotProps={{ input: { step: 60 } }}
            sx={{ width: '100%' }}
          />
          <FormHelperText>{t('trackingEventControl.timestampHint')}</FormHelperText>
          {timestampError ? (
            <FormHelperText sx={{ color: 'danger.500' }}>{timestampError}</FormHelperText>
          ) : null}
        </FormControl>
      ) : null}
    </FormControl>
  );
}
